import { render, staticRenderFns } from "./StackGrade.vue?vue&type=template&id=ffafb2a0&scoped=true&"
import script from "./StackGrade.vue?vue&type=script&lang=js&"
export * from "./StackGrade.vue?vue&type=script&lang=js&"
import style0 from "./StackGrade.vue?vue&type=style&index=0&id=ffafb2a0&prod&lang=css&"
import style1 from "./StackGrade.vue?vue&type=style&index=1&id=ffafb2a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffafb2a0",
  null
  
)

export default component.exports